module.exports = __webpack_public_path__ + "media/site_templates/www.localtilers.com.au/images/feature_1-c94056f2c2946ad2472a4d743d25abaf.jpeg";